import { useContext } from "react";
import { ToastContext } from "../components/common/ToastProvider";

/**
 * Shared toast hook. Must be used inside <ToastProvider>.
 *
 * Usage:
 *   const toast = useToast();
 *   toast.success("Saved!");
 *   toast.error("Something went wrong");
 *   toast.info("Loading…");
 */
export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used inside <ToastProvider>");
  }
  return ctx;
}
